import React from "react";

const ContactUs: React.FC = () => {
  return (
    <section className="schedule-three ngo_list_wrapper ngo_lists">
      <div className="container">
        <div className="schedule-three__top">
          <div
            className="section-title text-center wow fadeInLeft"
            data-wow-delay="100ms"
          >
            <h2 className="section-title__title">ImpactUp - Contact Us</h2>
          </div>
        </div>
        <div className="schedule-three__bottom">
          <p className="event-two__text">
            Have questions about this Privacy Policy or your data?
          </p>
          <p className="event-two__text">
            You can contact us at{" "}
            <a href="mailto:support@impactup.ai">support@impactup.ai</a>. We are
            here to help you with any concerns or inquiries you may have
            regarding your privacy and data security.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
